import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message, SelectItem } from 'primeng/api';
import { MenuDTO } from 'src/app/admihair/api/dto/menu-dto';
import { Permissao } from 'src/app/admihair/api/dto/permissao';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { MenuServiceProjeto } from 'src/app/admihair/service/menu.service';
import { PermissaoService } from 'src/app/admihair/service/permissao.service';

@Component({
  selector: 'app-menu-editar',
  templateUrl: './menu-editar.component.html',
  styleUrls: ['./menu-editar.component.scss']
})
export class MenuEditarComponent implements OnInit {

  constructor(private activatedRouter: ActivatedRoute, 
    private permissaoService: PermissaoService,
    private menuService: MenuServiceProjeto,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;

  id?: number;
  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  loadingMenu: boolean = false;
  menu?: MenuDTO;
  listaMenus: SelectItem[] = [ {label: 'Nenhum', value: null }];
  permissoes: SelectItem[] = [];

  ngOnInit(): void {
    this.loadingMenu = true;
    this.carregarIdMenu();
    this.listarMenus();
  }

  listarMenus(){
    this.menuService.listarTodos().subscribe({
      next: (data: MenuDTO[]) => {
        data.map(menu => this.listaMenus.push(({label: menu.descricao, value: menu.id})));
        this.listarPermissoes();
      },
      error: (err: any) => {
        this.loadingMenu = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  listarPermissoes(){
    this.permissaoService.listarTodos().subscribe({
      next: (data: Permissao[]) => {
        this.permissoes = data.map(item => ({label: `${item.descricao} - ${item.tipo}`, value: item}));
        this.buscarMenuPorId();
      },
      error: (err: any) => {
        this.loadingMenu = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  buscarMenuPorId(){
    this.menuService.buscarPorId(this.id).subscribe({
      next: (data: MenuDTO) => {
        this.menu = data;
        this.loadingMenu = false;
      },
      error: (err: any) => {
        this.loadingMenu = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  atualizar(){
    this.progressoRequisicao = true;
    this.menuService.atualizar(this.menu).subscribe({
      next: (data: MenuDTO) => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      }
    });
    
  }

  carregarIdMenu(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
    
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }
  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  

}
